import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { FieldTypeOnefileComponent } from '../../../shared/components/field-type-onefile/field-type-onefile.component';
import { FormsModule } from '@angular/forms';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { FieldTypeTextSimpleComponent } from "../../../shared/components/field-type-text/field-type-text-simple/field-type-text-simple.component";

@Component({
    selector: 'upload-report',
    templateUrl: './upload-report.component.html',
    standalone: true,
    imports: [AfTranslateDirective, FormsModule, FieldTypeOnefileComponent, FieldTypeTextSimpleComponent]
})
export class UploadReportComponent {
  constructor(private translate: AfTranslateFactory,
    private modalService: ModalServiceService,
    private dialogRef: DynamicDialogRef<UploadReportComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  uploadReport:any = {
    reportVersions: this.dialogConfig.data.reportVersions,
    extensionFileName: '',
    fieldInfo: {
      label: this.translate.instant('upload-report.upload-field-label') + ' (.docx ' + this.translate.instant('common.or') + ' .pdf)',
      fieldId: 'file-info',
      accept: '.docx,.pdf',
      required: true,
    },
    nameInfo: {
      label: this.translate.instant('rename-modal.name-report'),
      required: true,
     },
    fileInfo: {},
    reportExtensionsList: ['.docx', '.pdf']
  }

  fileSelected(e:any) {
    this.uploadReport.file = e.newValue;
    this.uploadReport.extensionFileName = e.newValue?e.newValue.name.substr(e.newValue.name.lastIndexOf('.')).toLowerCase().trim():'';
    this.validateExtension();
    if(this.uploadReport.fileName){
      this.validateNameReport();
    }
  }

  validateExtension(){
    this.uploadReport.fieldInfo.error = false;
    delete this.uploadReport.fieldInfo.errorText;
    if(!this.checkExtensionsList()){
      this.uploadReport.fieldInfo.error = true;
      this.uploadReport.fieldInfo.errorText = this.translate.instant('upload-report.format-errors') + ' ' + this.uploadReport.reportExtensionsList.join(' '+this.translate.instant('common.and')+' ');
    }
  }

  checkExtensionsList(){
    return Boolean(this.uploadReport.reportExtensionsList.filter((reportExtension:any)=>this.uploadReport.extensionFileName === reportExtension).length)
  }

  nameSelected(e: any){
    if(!e.newValue && this.uploadReport.fileName){
      this.uploadReport.nameInfo.error = false;
      delete this.uploadReport.nameInfo.errorText;
    }
    this.uploadReport.fileName = e.newValue;
    if(this.uploadReport.fileName){
      this.validateNameReport();
    }
  }

  validateNameReport() {
    this.uploadReport.nameInfo.error = false;
    delete this.uploadReport.nameInfo.errorText;
    this.uploadReport.fileReport = this.uploadReport.fileName + this.uploadReport.extensionFileName;
    for (let index in this.uploadReport.reportVersions) {
      let version = this.uploadReport.reportVersions[index];
      let versionFileName = version.editPath.substr(version.editPath.lastIndexOf('/') + 1);
      if (this.uploadReport.fileReport.toLowerCase().trim() === versionFileName.toLowerCase().trim()) {
        this.uploadReport.nameInfo.error = true;
        this.uploadReport.nameInfo.errorText = this.translate.instant('rename-modal.error-title-report');
        break;
      }
    }
  }

  validateFields(){
    if(!this.uploadReport.file){
      this.uploadReport.fieldInfo.error = true;
    }
    if(!this.uploadReport.fileName){
      this.uploadReport.nameInfo.error = true;
    }
    if(this.uploadReport.nameInfo.error || this.uploadReport.fieldInfo.error){
      this.modalService.errorModal({ text: this.translate.instant('export-modal.error-validation') });
    }else{
      this.handleAccept();
    }
  }

  handleAccept() {
    this.dialogRef.close({
      result: 'ok',
      file: this.uploadReport.file,
      fileName: this.uploadReport.fileReport
    });
  };

  handleDismiss() {
    this.dialogRef.close({
      result: 'cancel',
    });
  };

}
